/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';
import type { StartDate } from './';
import {
    StartDateFromJSON,
    StartDateFromJSONTyped,
    StartDateToJSON,
} from './';

/**
 * 
 * @export
 * @interface StartDateWithOrigin
 */
export interface StartDateWithOrigin {
    /**
     * 
     * @type {Origin}
     * @memberof StartDateWithOrigin
     */
    origin: Origin;
    /**
     * 
     * @type {StartDate}
     * @memberof StartDateWithOrigin
     */
    startDate: StartDate;
}

/**
 * Check if a given object implements the StartDateWithOrigin interface.
 */
export function instanceOfStartDateWithOrigin(value: object): value is StartDateWithOrigin {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function StartDateWithOriginFromJSON(json: any): StartDateWithOrigin {
    return StartDateWithOriginFromJSONTyped(json, false);
}

export function StartDateWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartDateWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': OriginFromJSON(json['origin']),
        'startDate': StartDateFromJSON(json['startDate']),
    };
}

export function StartDateWithOriginToJSON(value?: StartDateWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'origin': OriginToJSON(value['origin']),
        'startDate': StartDateToJSON(value['startDate']),
    };
}

